const apiUrl = process.env.REACT_APP_API_URL;
export const PostBundles = async ( id : number | null, nom : string, valor : string, env : string, page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/bundles`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({id, nom, valor, env})
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};